import styled from "@emotion/styled";

const StyledContainer = styled.div`
  .dropdown-button {
    height: 37.5px;
  }
  .ui-search-container {
    input {
      border-radius: 4px;
      border: 1px solid #e7e7e7;
      height: 37.5px;
    }
  }
  .dropdown-options {
    padding: 4px 3px;
    ul {
      padding: 0;
      margin: 0;
      list-style: none;
      .dropdown-option {
        padding: 8px 12px;
        border-radius: 8px;
        cursor: pointer;
        &:hover {
          background: #f3f3f3;
        }
        &.active {
          border-radius: 8px;
          background: #f3f3f3;
        }
      }
    }
  }
`;

export default StyledContainer;
